// extracted by mini-css-extract-plugin
export default {"expenses":"Expenses_expenses__qML5n","not-found":"Expenses_not-found__QR678"};